import RadioGroup from "@/components/forms/radio-group";
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Wrench, AlertTriangle } from 'lucide-react';
import type { DeclarationStepProps } from '@/pages/accident/declaration-sinistre/types';

const DeclarationReparateur = (props: DeclarationStepProps) => {
    const { errors, values, setValue } = props;

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <Wrench className="w-5 h-5 text-primary" />
                    Réparateur
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-8">
                <RadioGroup
                    label="Connaissez-vous le garage qui fera les réparations de votre véhicule ?"
                    name="vehicule"
                    setValue={setValue}
                    options={[{ value: 'T', label: 'Oui' }, { value: 'F', label: 'Non' }]}
                    value={values.vehicule}
                    error={errors.vehicule}
                    required
                />
                {values.vehicule === "F" && values.catsinorigin !== "10.0" && (
                    <Alert variant="destructive">
                        <AlertTriangle className="h-4 w-4" />
                        <AlertDescription>
                            <strong>ATTENTION</strong> : Si votre véhicule ne se trouve pas chez un garagiste, le passage de l'expert ne pourra être planifié.
                        </AlertDescription>
                    </Alert>
                )}
            </CardContent>
        </Card>
    );
};

export default DeclarationReparateur;
